import { OutboundAction } from './actions.ts'
import { HandlerRegistry } from "@/services/IframeBridge/messagesTypes.ts";
import { IframeBridge } from "@/services/IframeBridge/IframeBridgeService.ts";

const SendIframe: HandlerRegistry<OutboundAction> = {
    deviceStatus: (payload) => {
        IframeBridge.send<OutboundAction, 'deviceStatus'>('deviceStatus', payload)
    },
    onDeviceResume: (payload) => {
        IframeBridge.send<OutboundAction, 'onDeviceResume'>('onDeviceResume', payload)
    },
}

export default SendIframe;